<mat-expansion-panel [expanded]="autoExpand" class="mat-elevation-z0">
  <mat-expansion-panel-header>
    <mat-panel-title class="bold">
      {{ 'common.labels.filters' | transloco }}
    </mat-panel-title>
  </mat-expansion-panel-header>
  <form [formGroup]="_filterForm" class="padding">
    <div class="flex-container">
      <mat-form-field class="form-field flex-item">
        <mat-label>{{ 'common.labels.referenceNumber' | transloco }}</mat-label>
        <input matInput [formControlName]="'referenceNumber'" [placeholder]="'common.labels.referenceNumber' | transloco" />
      </mat-form-field>
      <mat-form-field class="form-field flex-item">
        <mat-select [formControlName]="'orderTypes'" [placeholder]="'common.labels.orderType' | transloco" multiple="true">
          @for (option of _orderTypeOptions; track option) {
            <mat-option [value]="option.value">
              {{ option.label }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
      <mat-form-field class="form-field flex-item">
        <mat-select [formControlName]="'status'" [placeholder]="'common.labels.orderStatus' | transloco" multiple="true">
          @for (option of _orderStatusTypeOptions; track option) {
            <mat-option [value]="option.value">
              {{ option.label }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>

    <lib-jurisdiction-selection
      (formReady)="handleJurisdictionFormReady($event)" [defaultCountry]="'CA'" [multiSelect]="true"
    [includeFederal]="true"></lib-jurisdiction-selection>

    <div class="spacer-small"></div>
    <div>
      <button mat-raised-button color="accent" class="margin-sides-5" [attr.aria-label]="'common.labels.clearFiltersButton' | transloco" type="button"
        (click)="onClear()" [disabled]="!_filterForm.dirty">
        {{ 'common.labels.clearFilters' | transloco }}
      </button>
      <button mat-raised-button color="accent" class="margin-sides-5" [attr.aria-label]="'common.labels.filterButton' | transloco" type="submit"
        (click)="onFilter()">
        {{ 'common.labels.filter' | transloco }}
      </button>
    </div>
  </form>
</mat-expansion-panel>